import React, { createContext, useState, useContext } from 'react';
// Create the context
const ResultsContext = createContext();
// Create a provider component
export const ResultsProvider = ({ children }) => {
    const [viewresults, setViewResults] = useState({ query: '', });
    return (
        <ResultsContext.Provider value={{ viewresults, setViewResults }}>
            {children}
        </ResultsContext.Provider>
    );
};
// Create a custom hook for easy access
export const useResults = () => useContext(ResultsContext);